import { render, staticRenderFns } from "./MedicalRecordsAll.vue?vue&type=template&id=3eed0f3e&scoped=true&"
import script from "./MedicalRecordsAll.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordsAll.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordsAll.vue?vue&type=style&index=0&id=3eed0f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eed0f3e",
  null
  
)

export default component.exports